import { withProtectedRoute } from "../../utils/HOC/withProtectedRoute";
// import { Materials } from "../../components/charts/Materials.chart";
import { MaterialsRevenue } from "../../components/charts/MaterialsRevenue.chart";
import { UserChurn } from "../../components/charts/UserChurn.chart";
import { StatiegeldDropsLocationCount, StatieItems } from "../../components";
import { MaterialConversion } from "../../components/charts/MaterialConversion.chart";

function BenchmarkingGraphs() {
  return (
    <>
      <div className="flex w-full justify-between">
        <h1 className="font-satoshi text-2xl font-bold text-dark mb-11">
          Benchmarking Graphs
        </h1>
        <div className="flex" />
      </div>
      {/* <Materials /> */}
      <MaterialsRevenue />
      <UserChurn />
      <StatiegeldDropsLocationCount />
      <StatieItems />
      <MaterialConversion />
    </>
  );
}

export default withProtectedRoute(BenchmarkingGraphs);
